module.exports = __webpack_public_path__ + "img/listPic2.c5c25bf3.jpg";